import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Navbar.css';

// Import flag images and logo
import enFlag from '../assets/en.png';
import ltFlag from '../assets/lt.png';
import logo from '../assets/logo.png';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const navLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/services', label: t('nav.services') },
    { path: '/case-studies', label: t('nav.caseStudies') },
    { path: '/contact', label: t('nav.contact') },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-container">
            <div className="navbar-content">
              <Link to="/" className="navbar-logo" aria-label="MDG Consulting Home">
                <img src={logo} alt="MDG Consulting" className="logo-img" width="40" height="40" loading="eager" />
                <span className="logo-text">MDG Consulting</span>
              </Link>

          <div className="navbar-desktop">
            <div className="navbar-links">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
            
            <div className="lang-switcher">
              <button
                onClick={() => changeLanguage('en')}
                className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
                aria-label="Switch to English"
                aria-pressed={i18n.language === 'en'}
              >
                <img src={enFlag} alt="English" className="flag-icon" width="20" height="15" loading="eager" />
                EN
              </button>
              <button
                onClick={() => changeLanguage('lt')}
                className={`lang-btn ${i18n.language === 'lt' ? 'active' : ''}`}
                aria-label="Switch to Lithuanian"
                aria-pressed={i18n.language === 'lt'}
              >
                <img src={ltFlag} alt="Lithuanian" className="flag-icon" width="20" height="15" loading="eager" />
                LT
              </button>
            </div>
          </div>

          <button 
            className="mobile-menu-btn" 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="mobile-menu">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsMobileMenuOpen(false)}
              className={`mobile-link ${location.pathname === link.path ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
          <div className="mobile-lang">
            <button 
              onClick={() => changeLanguage('en')} 
              className={i18n.language === 'en' ? 'active' : ''}
              aria-label="Switch to English"
              aria-pressed={i18n.language === 'en'}
            >
              <img src={enFlag} alt="English" className="flag-icon" width="20" height="15" loading="eager" />
              English
            </button>
            <button 
              onClick={() => changeLanguage('lt')} 
              className={i18n.language === 'lt' ? 'active' : ''}
              aria-label="Switch to Lithuanian"
              aria-pressed={i18n.language === 'lt'}
            >
              <img src={ltFlag} alt="Lithuanian" className="flag-icon" width="20" height="15" loading="eager" />
              Lietuvių
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
